import createAxios from './create.axios'

const API_BASE_URL = process.env.VUE_APP_API_HOST || 'http://localhost:8020'

export default createAxios(
  API_BASE_URL,
  {
    useAuth: false,
    globalError: true
  }
)
